// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"8921153f","220":"d2980f1d","388":"e369c2ab","389":"69ce888d","450":"6a90bc67","528":"30a38fd1","571":"5a8a39f9","690":"c93c85ec","751":"4716e83d","983":"65ead625"}[chunkId] + ".chunk.css";
};